//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default{
  data(){
    return{
      shengjiForm:{
        websize:'',
        daikuan:'',
        subweb:'',
        mysql:'',
        mssql:'',
        id:'',
        type:'',
        config:[],
        pset:[],
        coupon:[],
        yhq:[],
        endtime:'',
        price:'',
        loading:false,
        money:''
      },
    }
  },
  mounted(){
    this.config()
  },
  methods: {
    async config() {
      this.couponInfo()
      await this.levelShow()
      await this.levelPrice()
    },
    async couponInfo() {
      this.$http.post('https://api.abeiyun.com/www/user.php','cmd=userinfo').then(({data})=>{
        if(data.response == 200) {
          this.shengjiForm.money = data.msg.money
          let onuse = data.msg.yhq.onuse.map((item, index) => {
            return {
              value: item.yhq_id,
              name: '(可优惠'+ item.money_all +'元，最低消费满'+ item.money_need +'元可使用)',
              yhq_use: item.yhq_use
            }
          })
          this.shengjiForm.yhq = onuse.filter(items => {
            return items.yhq_use === '续费'
          })
          this.shengjiForm.yhq.unshift({
            value: '',
            name: '不使用优惠券',
            yhq_use: ''
          })
        }
      })
    },
    async levelShow() {
      let data = 'cmd=vhost_show'+
        '&yewu_id='+ this.$route.params.id
      await this.$http.post('https://api.abeiyun.com/www/upgrade.php',data).then(({data})=>{
        if(data.response == 200){
          this.shengjiForm.type = data.msg[0].id
          this.shengjiForm.websize = data.msg1.websize
          this.shengjiForm.mysql = data.msg1.mysql
          this.shengjiForm.mssql = data.msg1.mssql
          this.shengjiForm.subweb = data.msg1.subweb
          this.shengjiForm.config = data.msg.map((item, index) => {
            return {
              value: item.id,
              label: item.pname,
            }
          })
        }else{
          this.$vux.alert.show({
            title: '提示信息',
            content: data.msg,
          })
        }
      })
    },
    Choose(id) {
      this.shengjiForm.type = id
      this.levelPrice()
    },
    async levelPrice() {
      this.shengjiForm.price = '价格计算中...'
      let data = 'cmd=vhost_price'+
        '&yewu_id='+ this.$route.params.id +
        '&new_type_id='+ this.shengjiForm.type +
        '&yhq_id='+ this.shengjiForm.coupon
      await this.$http.post('https://api.abeiyun.com/www/upgrade.php',data).then(({data})=>{
        if(data.response == 200){
          this.shengjiForm.pset = data.pset
          this.shengjiForm.price = data.msg
        }else{
          this.$vux.alert.show({
            title: '提示信息',
            content: data.msg,
          })
        }
      })
    },
    async Level() {
      let data = 'cmd=vhost_upgrade'+
        '&yewu_id='+ this.$route.params.id +
        '&new_type_id='+ this.shengjiForm.type +
        '&yhq_id='+ this.shengjiForm.coupon
      let _this = this
      this.$http.post('https://api.abeiyun.com/www/upgrade.php',data).then(({data})=>{
        if(data.response == 200){
          this.$vux.alert.show({
            title: '提示信息',
            content: data.msg,
          })
        }else{
          this.$vux.alert.show({
            title: '提示信息',
            content: data.msg,
          })
        }
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/console/hostlevel.vue